"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListControlsLayout = exports.ListControlsLayoutDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var loader_1 = require("./loader");
var icon_button_1 = require("./icon-button");
var use_icons_1 = require("../../hooks/use-icons");
exports.ListControlsLayoutDefaultProps = {
  loading: false
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: 0 auto;\n    position: relative;\n    z-index: 80;\n    flex-wrap: nowrap;\n    display: flex;\n    background: #FFF;\n    justify-content: space-between;\n    box-sizing: border-box;\n    padding: 0 0 0 ", ";\n    border: 1px solid ", ";\n    border-radius: ", ";\n    box-shadow: 0px 2px 1px inset rgba(0,0,0, 0.02);\n\n    &:focus-within {\n      border-color: ", ";\n    }\n  "], ["\n    margin: 0 auto;\n    position: relative;\n    z-index: 80;\n    flex-wrap: nowrap;\n    display: flex;\n    background: #FFF;\n    justify-content: space-between;\n    box-sizing: border-box;\n    padding: 0 0 0 ", ";\n    border: 1px solid ", ";\n    border-radius: ", ";\n    box-shadow: 0px 2px 1px inset rgba(0,0,0, 0.02);\n\n    &:focus-within {\n      border-color: ", ";\n    }\n  "])), theme_1.theme.UNIT(4), theme_1.theme.COLOR('line-filter'), theme_1.theme.UNIT(2), theme_1.theme.COLOR('primary')),
  tablet: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: 0 0 0 ", ";\n  "], ["\n    padding: 0 0 0 ", ";\n  "])), theme_1.theme.UNIT(4))
});
var MainStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    flex-grow: 1;\n  "], ["\n    flex-grow: 1;\n  "])))
});
var AsideStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    position: absolute;\n    width: 100%;\n    box-sizing: border-box;\n    background: #FCFCFC;\n    white-space: nowrap;\n    flex-shrink: 0;\n    padding: ", ";\n    display: none;\n    top: 40px;\n    border-bottom: 1px solid ", ";\n    right: 0;\n    z-index: 400;\n    align-items: center;\n    justify-content: flex-end;\n\n    ", "\n  "], ["\n    position: absolute;\n    width: 100%;\n    box-sizing: border-box;\n    background: #FCFCFC;\n    white-space: nowrap;\n    flex-shrink: 0;\n    padding: ", ";\n    display: none;\n    top: 40px;\n    border-bottom: 1px solid ", ";\n    right: 0;\n    z-index: 400;\n    align-items: center;\n    justify-content: flex-end;\n\n    ", "\n  "])), theme_1.theme.UNIT(3), theme_1.theme.COLOR('line-subtle'), function (props) {
    return props.isVisible && (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      display: flex;\n    "], ["\n      display: flex;\n    "])));
  }),
  tablet: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    display: flex;\n    background: none;\n    position: static;\n    border-bottom: none;\n    justify-content: flex-start;\n    padding: 0;\n    padding-right: ", ";\n  "], ["\n    display: flex;\n    background: none;\n    position: static;\n    border-bottom: none;\n    justify-content: flex-start;\n    padding: 0;\n    padding-right: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var LoaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    z-index: 100;\n    text-transform: uppercase;\n    top: 8px;\n    position: relative;\n    margin-right: ", ";\n    font-size: ", ";\n    right: 32px;\n  "], ["\n    z-index: 100;\n    text-transform: uppercase;\n    top: 8px;\n    position: relative;\n    margin-right: ", ";\n    font-size: ", ";\n    right: 32px;\n  "])), theme_1.theme.UNIT(3), theme_1.theme.FONT_SIZE(14)),
  tablet: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    top: 0px;\n    right: 0;\n  "], ["\n    top: 0px;\n    right: 0;\n  "])))
});
var LoadingAndAsideStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n  "], ["\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n  "])))
});
var MoreButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    position: absolute;\n    right: ", ";\n    top: ", ";\n    display: flex;\n\n    ", "\n  "], ["\n    position: absolute;\n    right: ", ";\n    top: ", ";\n    display: flex;\n\n    ", "\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(2.5), function (props) {
    return props.isActive && (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), theme_1.theme.COLOR('dark'));
  }),
  tablet: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "]))),
  desktop: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "])))
});
// --------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Main: styled_components_1.default.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), MainStyles),
  Aside: styled_components_1.default.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), AsideStyles),
  MoreButton: (0, styled_components_1.default)(icon_button_1.IconButton)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), MoreButtonStyles),
  LoadingAndAside: styled_components_1.default.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), LoadingAndAsideStyles),
  Loader: (0, styled_components_1.default)(loader_1.Loader)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), LoaderStyles)
};
var ListControlsLayout = function (props) {
  var className = props.className,
    children = props.children,
    aside = props.aside,
    loading = props.loading;
  var Icons = (0, use_icons_1.useIcons)();
  var _a = __read(React.useState(false), 2),
    moreVisible = _a[0],
    setMoreVisible = _a[1];
  return React.createElement(My.Container, {
    className: className
  }, React.createElement(My.Main, null, children), React.createElement(My.LoadingAndAside, null, loading && React.createElement(My.Loader, {
    spaceUnits: 0
  }, ' '), aside && React.createElement(My.Aside, {
    isVisible: moreVisible
  }, aside), aside && React.createElement(My.MoreButton, {
    isActive: moreVisible,
    onClick: function () {
      return setMoreVisible(!moreVisible);
    },
    icon: React.createElement(Icons.EllipsisCircle, null)
  })));
};
exports.ListControlsLayout = ListControlsLayout;
exports.ListControlsLayout.defaultProps = exports.ListControlsLayoutDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19;